package com.appsyde.shared.presentation.screen.component.history.helper

import kotlin.js.Date

fun formatHistoryTime(atMs: Long?): String {
    if (atMs == null) return ""
    val d = Date(atMs.toDouble())

    val day = d.getDate().toString().padStart(2, '0')
    val month = (d.getMonth() + 1).toString().padStart(2, '0')
    val hour = d.getHours().toString().padStart(2, '0')
    val min = d.getMinutes().toString().padStart(2, '0')

    return "$day/$month • $hour:$min"
}
